/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // === PDP Gallery Arrows: hover-reveal by side, clean circles ===
  function styleArrow(arrow) {
    arrow.style.setProperty('opacity', '0', 'important');
    arrow.style.setProperty('transition', 'opacity .2s ease', 'important');
    arrow.style.setProperty('width', '36px', 'important');
    arrow.style.setProperty('height', '36px', 'important');
    arrow.style.setProperty('background-color', 'rgba(0,0,0,.2)', 'important');
    arrow.style.setProperty('fill', 'rgb(255,255,255)', 'important');
    arrow.style.setProperty('box-shadow', '0 1px 4px rgba(0,0,0,.12)', 'important');
    var svg = arrow.querySelector('svg');
    if (svg) {
      svg.setAttribute('width', '14');
      svg.setAttribute('height', '14');
    }
    if (arrow.classList.contains('pwzrswiper-btn-next')) {
      arrow.style.setProperty('right', '12px', 'important');
    } else {
      arrow.style.setProperty('left', '12px', 'important');
    }
    arrow.dataset.styled = '1';
  }

  // === PDP Gallery: 4:5 aspect ratio with cover ===
  function styleSlides() {
    var wrapper = document.getElementById('pwzrswiper-container-wrapper');
    if (!wrapper) return;

    wrapper.querySelectorAll('.pwzrswiper-slide').forEach(function(slide) {
      if (slide.dataset.ratio) return;
      slide.style.setProperty('padding-bottom', '125%', 'important');
      slide.dataset.ratio = '1';
    });

    wrapper.querySelectorAll('.pwzrswiper-slide img').forEach(function(img) {
      if (img.dataset.cover) return;
      img.style.setProperty('position', 'absolute', 'important');
      img.style.setProperty('top', '0', 'important');
      img.style.setProperty('left', '0', 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', '100%', 'important');
      img.style.setProperty('object-fit', 'cover', 'important');
      img.dataset.cover = '1';

      var src = img.getAttribute('src') || img.getAttribute('data-src');
      if (src && !img.getAttribute('srcset')) {
        var base = src.replace(/[?&]width=\d+/, '');
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        img.setAttribute('srcset',
          base + sep + 'width=1200 600w, ' +
          base + sep + 'width=1600 800w, ' +
          base + sep + 'width=1980 990w'
        );
        img.setAttribute('sizes', '(max-width: 767px) 100vw, 50vw');
      }
    });

    var swiperWrapper = document.getElementById('pwzrswiper-wrapper');
    if (swiperWrapper) {
      swiperWrapper.style.setProperty('height', 'auto', 'important');
    }
  }

  function styleAll() {
    var wrapper = document.getElementById('pwzrswiper-container-wrapper');
    if (wrapper) {
      wrapper.querySelectorAll('.pwzrswiper-btn-prev, .pwzrswiper-btn-next').forEach(function(a) {
        if (a.dataset.styled !== '1') styleArrow(a);
      });
      styleSlides();
    }

    // === Cart: Shop Pay only ===
    var acc = document.querySelector('shopify-accelerated-checkout-cart');
    if (acc && !acc.dataset.filtered) {
      acc.dataset.filtered = '1';
      try {
        var configs = JSON.parse(acc.getAttribute('wallet-configs'));
        var shopPayOnly = configs.filter(function(c) { return c.name === 'shop_pay'; });
        acc.setAttribute('wallet-configs', JSON.stringify(shopPayOnly));
      } catch(e) {}
      // Remove non-Shop Pay button elements
      ['shopify-amazon-pay-button', 'shopify-paypal-button', 'shopify-google-pay-button'].forEach(function(tag) {
        var el = acc.querySelector(tag);
        if (el) el.remove();
      });
    }
  }

  new MutationObserver(styleAll)
    .observe(document.body, { childList: true, subtree: true });

  // Side-aware hover via event delegation
  document.addEventListener('mousemove', function(e) {
    var wrapper = document.getElementById('pwzrswiper-container-wrapper');
    if (!wrapper || !wrapper.contains(e.target)) return;
    var prev = wrapper.querySelector('.pwzrswiper-btn-prev');
    var next = wrapper.querySelector('.pwzrswiper-btn-next');
    if (!prev || !next) return;
    var mid = wrapper.getBoundingClientRect().left + wrapper.getBoundingClientRect().width / 2;
    if (e.clientX < mid) {
      prev.style.setProperty('opacity', '1', 'important');
      next.style.setProperty('opacity', '0', 'important');
    } else {
      next.style.setProperty('opacity', '1', 'important');
      prev.style.setProperty('opacity', '0', 'important');
    }
  });

  document.addEventListener('mouseout', function(e) {
    var wrapper = document.getElementById('pwzrswiper-container-wrapper');
    if (!wrapper || !wrapper.contains(e.target)) return;
    if (e.relatedTarget && wrapper.contains(e.relatedTarget)) return;
    wrapper.querySelectorAll('.pwzrswiper-btn-prev, .pwzrswiper-btn-next').forEach(function(a) {
      a.style.setProperty('opacity', '0', 'important');
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
